import DevicesListStatus from 'drivers/devicesListStatus';
import DevicesList from 'drivers/devicesList';
import StorageKeys from 'enum/storages.enum';
import {
  getTizenVersionFromUA,
  hasLegacyTizenEpAvPlayAPI,
  hasTizenTEPAvPlayAPI,
  isTizenVersionTEP,
} from 'utils/device/tizenPlatform';
import { tLog, tError } from 'utils/device/tizenLog';

import Storages from 'storages';

function getDevice() {
  if(window.android){
    DevicesListStatus.DevicesListStatus.isANDROID = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.ANDROID, '2025'];
  }
  if (navigator.userAgent.indexOf('Maple 5') >= 0) {
    DevicesListStatus.DevicesListStatus.isSAMSUNG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.SAMSUNG, '2010'];
  } else if (navigator.userAgent.indexOf('Maple 6') >= 0) {
    DevicesListStatus.DevicesListStatus.isSAMSUNG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.SAMSUNG, '2011'];
  } else if (navigator.userAgent.indexOf('SmartTV; Maple2012') >= 0) {
    DevicesListStatus.DevicesListStatus.isSAMSUNG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.SAMSUNG, '2012'];
  } else if (navigator.userAgent.indexOf('SmartTV+2013; Maple2012') >= 0) {
    DevicesListStatus.DevicesListStatus.isSAMSUNG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.SAMSUNG, '2013'];
  } else if (navigator.userAgent.indexOf('SmartTV+2014; Maple2012') >= 0) {
    DevicesListStatus.DevicesListStatus.isSAMSUNG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.SAMSUNG, '2014'];
  } else if (navigator.userAgent.indexOf('SmartTV+2015; Maple2012') >= 0) {
    DevicesListStatus.DevicesListStatus.isSAMSUNG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.SAMSUNG, '2015'];
  } else if (navigator.userAgent.indexOf('Maple') >= 0) {
    DevicesListStatus.DevicesListStatus.isSAMSUNG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.SAMSUNG, '']; // to cover the new models comming from future
  } else if (navigator.userAgent.indexOf('Tizen') >= 0) {
    var tizenVersion = getTizenVersionFromUA();
    if (tizenVersion == null) {
      tizenVersion = 2;
    }
    var hasAvplay   = hasTizenTEPAvPlayAPI();
    var hasEpavplay = hasLegacyTizenEpAvPlayAPI();
    var ua          = navigator.userAgent.slice(0, 120);
    tLog('[Device]', 'UA=' + ua);
    tLog('[Device]', 'tizenVersion=' + tizenVersion + ' avplay=' + hasAvplay + ' epavplay=' + hasEpavplay);

    var tizenYearMap = { 2: '2015', 3: '2017', 4: '2019', 5: '2020', 6: '2021', 7: '2022', 8: '2023' };
    var tizenYear = tizenYearMap[Math.floor(tizenVersion)] || String(new Date().getFullYear());
    // Tizen 2.4.0 shipped in 2016 TVs — special case within major 2
    if (navigator.userAgent.indexOf('Tizen 2.4.0') >= 0) {
      tizenYear = '2016';
    }
    // BU8000 and similar report Tizen 6.5 — must use parseFloat, not major digit only
    if (tizenVersion >= 6.5 && tizenVersion < 7) {
      tizenYear = '2022';
    }
    var useTEP =
      isTizenVersionTEP(tizenVersion) ||
      (hasAvplay && !hasEpavplay);
    if (useTEP) {
      // TZ > 6.0 — TEP (webapis.avplay / avplayextension.js)
      DevicesListStatus.DevicesListStatus.isTIZEN_TEP = true;
      Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
      tLog('[Device]', '✅ TIZEN_TEP year=' + tizenYear);
      return [DevicesList.DevicesList.TIZEN_TEP, tizenYear];
    } else {
      // TZ <= 6.0 — legacy H.Browser (webapis.epavplay / b2bavplay.js)
      DevicesListStatus.DevicesListStatus.isTIZEN = true;
      Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
      tLog('[Device]', '✅ TIZEN_LEGACY year=' + tizenYear + ' epavplay path');
      return [DevicesList.DevicesList.TIZEN, tizenYear];
    }
  } else if (navigator.userAgent.indexOf('LG NetCast.TV-2011') >= 0) {
    DevicesListStatus.DevicesListStatus.isLG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.LG, '2011'];
  } else if (navigator.userAgent.indexOf('LG NetCast.TV-2012') >= 0) {
    DevicesListStatus.DevicesListStatus.isLG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.LG, '2012'];
  } else if (navigator.userAgent.indexOf('LG NetCast.TV') >= 0) {
    DevicesListStatus.DevicesListStatus.isLG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.LG, '2013'];
  } else if (navigator.userAgent.indexOf('LG SimpleSmart.TV-2016') >= 0) {
    DevicesListStatus.DevicesListStatus.isLG = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.LG, '2016'];
  } else if (navigator.userAgent.indexOf('NETTV/3') >= 0) {
    DevicesListStatus.DevicesListStatus.isPHILIPS = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.PHILIPS, '2011'];
  } else if (navigator.userAgent.indexOf('NETTV/4.0') >= 0) {
    DevicesListStatus.DevicesListStatus.isPHILIPS = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.PHILIPS, '2012'];
  } else if (navigator.userAgent.indexOf('NETTV/') >= 0) {
    DevicesListStatus.DevicesListStatus.isPHILIPS = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.PHILIPS, '2013'];
  } else if (navigator.userAgent.indexOf('DuneHD/') >= 0) {
    DevicesListStatus.DevicesListStatus.isDUNEHD = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.DUNEHD, ''];
  } else if (navigator.userAgent.indexOf('Viera/1.') >= 0) {
    DevicesListStatus.DevicesListStatus.isVIERA = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.VIERA, '2012'];
  } else if (navigator.userAgent.indexOf('Viera/3.') >= 0) {
    DevicesListStatus.DevicesListStatus.isVIERA = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.VIERA, '2013'];
  } else if (navigator.userAgent.indexOf('SmartTvA/') >= 0) {
    DevicesListStatus.DevicesListStatus.isAlliance = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.Alliance, 'generic'];
  } else if (navigator.userAgent.indexOf('ToshibaTP/') >= 0) {
    DevicesListStatus.DevicesListStatus.isAlliance = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.Alliance, 'toshiba'];
  } else if (navigator.userAgent.match(/playstation 3/gi)) {
    DevicesListStatus.DevicesListStatus.isPlaystation = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.Playstation, '3'];
  } else if (navigator.userAgent.match(/playstation 4/gi)) {
    DevicesListStatus.DevicesListStatus.isPlaystation = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.Playstation, '4'];
  } else if (navigator.userAgent.indexOf('Web0S') >= 0 && navigator.userAgent.indexOf('537.41') >= 0) {
    DevicesListStatus.DevicesListStatus.isWEBOS = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.WEBOS, '1.x'];
  } else if (navigator.userAgent.indexOf('Web0S') >= 0 && navigator.userAgent.indexOf('538.2') >= 0) {
    DevicesListStatus.DevicesListStatus.isWEBOS = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.WEBOS, '2.x'];
  } else if (navigator.userAgent.indexOf('Web0S') >= 0 && navigator.userAgent.indexOf('537.36') >= 0) {
    DevicesListStatus.DevicesListStatus.isWEBOS = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.WEBOS, '3.x'];
  } else if (navigator.userAgent.indexOf('Web0S') >= 0) {
    DevicesListStatus.DevicesListStatus.isWEBOS = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.WEBOS, '']; // to cover the new models comming from future
  } else if (navigator.userAgent.indexOf('Hisense') >= 0) {
    DevicesListStatus.DevicesListStatus.isHISENSE = true;
    Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);
    return [DevicesList.DevicesList.HISENSE, ''];
  }

  DevicesListStatus.DevicesListStatus.isDEFAULT = true;
  Storages.MainStorage.setItem(StorageKeys.Keys.DEVICELIST, DevicesListStatus.DevicesListStatus);

  return [DevicesList.DevicesList.DEFAULT, ''];
}

const obj = { getDevice };

export default obj;
